// *** novacontaprestador.jsx ***
// *** autor: W de Paula / MVinfo ***
// *** data: 22/07/24 | 14h45 |
// *** data: 20/01/25 | 11h29 | inclusão de tratativas de escolha de PAÍS no momento do cadastro; com isso o DDI será automático também




import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import apiaxios from '../../Services/apiaxios';
import InputMask from 'react-input-mask';
import Swal from 'sweetalert2';
import { encryptPass } from '../../Services/cryptosenha';

import "./novaconta.css";

import AgendexLogo from '../../Assets/agendex/iconLogoAgendex.png';
import AgendexPrestadorLogo from '../../Assets/agendex/logoagendexprestador.png'

function NovaContaPrestador() {
    var ano = new Date().getFullYear();

    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        nome: '',
        email: '',
        confirmaEmail: '', // acrescentada 24/10/24w17h41
        telefone: '',
        cep: '',
        uf: '',
        cidade: '',
        bairro: '',
        rua: '',
        complemento: '',
        numero: '',
        senha: '',
        confirmaSenha: '',
        politicaPrivacidade: false,
        termosUso: false,
    });

    const [isFormValid, setIsFormValid] = useState(false);
    // const [paises, setPaises] = useState([]); // State for countries // acrescentado 17/1/25w
    const [paisSelecionado, setPaisSelecionado] = useState(null); // State for selected country ID // acrescentado 17/1/25w

    // useEffect(() => {
    //     async function fetchPaises() {
    //     const response = await apiaxios.get('/paises'); // Replace with your API endpoint
    //     setPaises(response.data);
    //     }
    //     fetchPaises();
    // }, []);

    useEffect(() => {
        async function fetchCEP() {
            if (formData.cep.length === 9) {
                try {
                    const response = await fetch(`https://viacep.com.br/ws/${formData.cep}/json/`);
                    const data = await response.json();
                    setFormData((prevData) => ({
                        ...prevData,
                        uf: data.uf || '',
                        cidade: data.localidade || '',
                        bairro: data.bairro || '',
                        rua: data.logradouro || '',
                        complemento: data.complemento || '',
                    }));
                } catch (error) {
                    console.error('Erro ao buscar CEP:', error);
                }
            }
        }
        fetchCEP();
    }, [formData.cep]);

    useEffect(() => {
        validateForm(formData);
    // }, [formData, paisSelecionado]);
    }, [formData]);

    const validateForm = () => {
        const nomeValido = formData.nome.length >= 5 && /^[a-zA-Z\s]+$/.test(formData.nome);
        const emailValido = /\S+@\S+\.\S+/.test(formData.email);
        const confirmaEmailValido = /\S+@\S+\.\S+/.test(formData.confirmaEmail);
        const telefoneValido = /^\(\d{2}\)\d{5}-\d{4}$/.test(formData.telefone);
        const cepValido = /^\d{5}-\d{3}$/.test(formData.cep);
        const ufValido = formData.uf.length > 0;
        const cidadeValido = formData.cidade.length > 0;
        const bairroValido = formData.bairro.length > 0;
        const ruaValido = formData.rua.length > 0;
        const numeroValido = formData.numero.length > 0;
        const emailsIguais = formData.email === formData.confirmaEmail;
        const senhaValida = formData.senha.length >= 3 && formData.senha.length <= 50;
        const senhasIguais = formData.senha === formData.confirmaSenha;
        const checkboxesMarcados = formData.politicaPrivacidade && formData.termosUso;

        setIsFormValid(nomeValido && emailValido && confirmaEmailValido && telefoneValido && cepValido && ufValido && cidadeValido && bairroValido && ruaValido && numeroValido && senhaValida && emailsIguais && senhasIguais && checkboxesMarcados);
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (name === 'nome') {
            if (/^[a-zA-Z\s]*$/.test(value)) {
                setFormData({
                    ...formData,
                    [name]: value
                });
            }
        } else {
            setFormData({
                ...formData,
                [name]: type === 'checkbox' ? checked : value
            });
        }
    };

    const handlePoliticaPrivacidade = () => {
        Swal.fire({
            title: 'Política de Privacidade',
            html: `<iframe src="https://www.freeprivacypolicy.com/live/7537ad5c-e32a-4dda-b746-a83891d57061" width="100%" height="400px"></iframe>`,
            width: '600px',
            showCloseButton: true,
            focusConfirm: false,
        });
    };

    const handleTermosUso = () => {
        Swal.fire({
            title: 'Termos de Uso',
            html: `<iframe src="https://www.freeprivacypolicy.com/live/7ade3469-ff51-4c9a-aff8-88d9211cc0c5" width="100%" height="400px"></iframe>`,
            width: '600px',
            showCloseButton: true,
            focusConfirm: false,
        });
    };

    const criarConta = async () => {
        if (!isFormValid) return;

        const { nome, email, telefone, uf, cidade, bairro, rua, complemento, numero, senha } = formData;

        const novaContaData = {
            nome,
            email,
            senha: encryptPass(senha),
            fone: telefone,
            endereco: `${rua} - ${numero} - ${complemento}`,
            bairro,
            cidade,
            uf,
            pais: 'BRASIL', // futuramente criar um campo exclusivo para o país
            nt_id: 1,
            cod_notificacao: 51 // novo prestador fez cadastro básico
        };

        try {
            const response = await apiaxios.post('/usuario/NovaContaPrestadorWeb', novaContaData);
            if (response.status === 201) {
                Swal.fire({
                    title: 'Sucesso!',
                    text: 'Conta criada com sucesso! Por favor, faça o login.',
                    icon: 'success',
                    confirmButtonText: 'OK'
                }).then(() => {
                    navigate('/app/login/prestador');
                });
            } else {
                const errorMessage = response?.data?.retorno || 'Erro ao criar conta.';
                Swal.fire('Erro', errorMessage, 'error');
            }
        // } catch (error) {
        //     const errorMessage = error.response?.data?.retorno || 'Erro ao criar conta.';
        //     Swal.fire('Erro', errorMessage, 'error');
        // }
        } catch (error) {
            console.error('Erro completo:', error);
            
            if (error.response && error.response.data) {
                // Servidor respondeu com erro
                const errorMessage = error.response.data.retorno || error.response.data.message || 'Erro ao criar conta.';
                Swal.fire('Erro', errorMessage, 'error');
            } else if (error.request) {
                // Sem resposta do servidor
                Swal.fire('Erro de Conexão', 'Não foi possível conectar ao servidor. Por favor, verifique se o servidor está rodando.', 'error');
            } else {
                // Outro erro
                Swal.fire('Erro', 'Ocorreu um erro inesperado: ' + error.message, 'error');
            }
        }
    };


    return (
        <section id="novacontaprestador">
            <div className="container login-container">
                <div className="row">
                    <div className="col-md-6 login-form-2">
                        <div className="login-logo">
                            <img src={AgendexLogo} alt="Agendex Logo" />
                        </div>
                        <img className="login-prestador-img" src={AgendexPrestadorLogo} alt="Nova Conta Prestador" />
                        <h3>Criar Conta Prestador (Empresa)</h3>

                        <div className="form-group mb-3">
                            <input type="text" className="form-control" id="nomeprestador" name="nome" value={formData.nome} onChange={handleChange} placeholder="Digite seu Nome (*)" />
                        </div>
                        <div className="form-group mb-3">
                            <input type="text" className="form-control" id="emailprestador" name="email" value={formData.email.toLowerCase()} onChange={handleChange} placeholder="Digite seu Email preferencial (*)" />
                        </div>
                        <div className="form-group mb-3">
                            <input type="text" className="form-control" id="confirmaemailprestador" name="confirmaEmail" value={formData.confirmaEmail.toLowerCase()} onChange={handleChange} placeholder="Repita seu Email (*)" />
                        </div>
                        <div className="form-group mb-3">
                            <InputMask
                                mask="(99)99999-9999"
                                value={formData.telefone}
                                onChange={handleChange}
                            >
                                {() => <input type="text" className="form-control" id="foneprestador" name="telefone" placeholder="Telefone com DDD (WhatsApp preferencial) (*)" />}
                            </InputMask>
                        </div>
                        <div className="form-group mb-3">
                            <InputMask
                                mask="99999-999"
                                value={formData.cep}
                                onChange={handleChange}
                            >
                                {() => <input type="text" className="form-control" id="cepprestador" name="cep" placeholder="CEP do endereço de sua empresa / negócio (*)" />}
                            </InputMask>
                        </div>
                        <div className="form-group mb-3">
                            <input type="text" className="form-control" id="ufprestador" name="uf" value={formData.uf} onChange={handleChange} placeholder="Estado/UF (*)" />
                        </div>
                        <div className="form-group mb-3">
                            <input type="text" className="form-control" id="logradouroprestador" name="rua" value={formData.rua} onChange={handleChange} placeholder="Rua/Ave onde está sua empresa (*)" />
                        </div>
                        <div className="form-group mb-3">
                            <input type="text" className="form-control" id="cidadeprestador" name="cidade" value={formData.cidade} onChange={handleChange} placeholder="Cidade de sua empresa (*)" />
                        </div>
                        <div className="form-group mb-3">
                            <input type="text" className="form-control" id="bairroprestador" name="bairro" value={formData.bairro} onChange={handleChange} placeholder="Bairro de sua empresa (*)" />
                        </div>
                        <div className="form-group mb-3">
                            <input type="text" className="form-control" id="numeroprestador" name="numero" value={formData.numero} onChange={handleChange} placeholder="Número (*)" />
                        </div>
                        <div className="form-group mb-3">
                            <input type="text" className="form-control" id="complementoprestador" name="complemento" value={formData.complemento} onChange={handleChange} placeholder="Complemento (Opcional)" />
                        </div>
                        <div className="form-group mb-3">
                            <input type="password" className="form-control" id="senhaprestador" name="senha" value={formData.senha} onChange={handleChange} placeholder="Senha (*)" />
                        </div>
                        <div className="form-group mb-3">
                            <input type="password" className="form-control" id="confirmasenhaprestador" name="confirmaSenha" value={formData.confirmaSenha} onChange={handleChange} placeholder="repita sua Senha (*)" />
                        </div>
                        <div className="form-group mb-3">
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" id="politicaprivacidade" name="politicaPrivacidade" checked={formData.politicaPrivacidade} onChange={handleChange} />
                                <label className="form-check-label" htmlFor="politicaprivacidade">
                                    Eu li e aceito a <button type="button" className="btn-link" onClick={handlePoliticaPrivacidade}>Política de Privacidade</button>.
                                </label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" id="termosuso" name="termosUso" checked={formData.termosUso} onChange={handleChange} />
                                <label className="form-check-label" htmlFor="termosuso">
                                    Eu li e aceito os <button type="button" className="btn-link" onClick={handleTermosUso}>Termos de Uso</button>.
                                </label>
                            </div>
                        </div>
                        <div className="form-group mt-4">
                            <button
                                type="button"
                                className={`btnSubmit ${isFormValid ? 'btn btn-primary' : 'btn btn-secondary disabled'}`}
                                disabled={!isFormValid}
                                onClick={criarConta}
                            >
                                Prestador Criar Conta 
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="textoRodape" >
                <Link to="/app/login">Já tenho conta. Toque para fazer login.</Link>
                <p > Desenvolvido por MVinfo Sistemas | WMX Group 2021 - {ano}</p>
            </div>
        </section>
    );
}

export default NovaContaPrestador;